import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';

function disableProductionConsoleOutput(): void {
    const noop = () => undefined;
    console.log = noop;
    console.info = noop;
    console.debug = noop;
    console.warn = noop;
}



if (environment.production) {
    enableProdMode();
    disableProductionConsoleOutput();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule, { ngZoneEventCoalescing: true })
    .catch(err => console.error(err));
    
